class ProductCustomization {
  constructor() {
    this.canvases = [];
    this.textInput = document.querySelector('input[name="properties[Name]"]');
    this.currentText = '';
    this.setupCarouselListeners();
    this.init();
    this.handleResize = this.handleResize.bind(this);
    window.addEventListener('resize', this.handleResize);
  }

  init() {
    try {
      // Initialize all canvases immediately, not just the active one
      const canvasElements = document.querySelectorAll('[data-canvas-index]');
      if (!canvasElements.length) {
        console.warn('No canvas elements found');
        return;
      }

      canvasElements.forEach((canvasElement, index) => {
        if (!fabric) {
          console.error('Fabric.js not loaded');
          return;
        }
        requestAnimationFrame(() => {
          this.initializeCanvas(canvasElement, index);
        });
      });

      if (this.textInput) {
        this.textInput.addEventListener('input', (e) => {
          this.currentText = e.target.value;
          this.updateAllCanvases(this.currentText);
        });
      }
    } catch (error) {
      console.error('Initialization failed:', error);
    }
  }

  calculateResponsiveFontSize(containerWidth, containerHeight, style) {
    // Base font size for a reference container size
    const baseWidth = 1200; // Reference width
    const baseHeight = 800; // Reference height
    const baseFontSize = style.fontSize;

    // Calculate scale factors
    const widthScale = containerWidth / baseWidth;
    const heightScale = containerHeight / baseHeight;

    // Use the smaller scale to ensure text fits both dimensions
    const scale = Math.min(widthScale, heightScale);

    // Calculate new font size
    return Math.round(baseFontSize * scale);
  }

  initializeCanvas(canvasElement, index) {
    try {
      if (!canvasElement || !fabric) return null;
      if (this.canvases[index]) return this.canvases[index];

      const container = canvasElement.parentElement;
      if (!container) {
        console.error('No container found for canvas', index);
        return null;
      }

      const width = Math.max(container.offsetWidth, 100);
      const height = Math.max(container.offsetHeight, 100);
      
      // Clear any existing canvas at this index
      if (this.canvases[index]) {
        this.canvases[index].dispose();
      }

      const fabricCanvas = new fabric.Canvas(canvasElement, {
        width,
        height,
        renderOnAddRemove: false,
        selection: false
      });
      
      this.canvases[index] = fabricCanvas;
      
      const style = this.getStyleForIndex(index);
      const responsiveFontSize = this.calculateResponsiveFontSize(width, height, style);
      const responsiveStrokeWidth = Math.max(2, Math.round((responsiveFontSize / style.fontSize) * style.strokeWidth));

      const text = new fabric.Text(this.currentText || '', {
        left: (width * style.left) / 100,
        top: (height * style.top) / 100,
        fontSize: responsiveFontSize,
        fill: style.color,
        fontFamily: style.fontFamily,
        stroke: style.stroke,
        strokeWidth: responsiveStrokeWidth,
        strokeUniform: true,
        strokeLineJoin: 'round',
        paintFirst: 'stroke',
        originX: 'center',
        originY: 'center',
        selectable: false
      });
      
      fabricCanvas.add(text);
      fabricCanvas.renderAll();
      return fabricCanvas;
    } catch (error) {
      console.error('Canvas initialization failed for index', index, error);
      return null;
    }
  }

  setupCarouselListeners() {
    const carousel = document.getElementById('product-gallery');
    if (!carousel) return;

    // Add listener for when slide starts
    carousel.addEventListener('slide.bs.carousel', (event) => {
      const nextSlide = event.relatedTarget;
      const canvas = nextSlide.querySelector('canvas');
      if (canvas) {
        const index = parseInt(canvas.getAttribute('data-canvas-index'));
        console.log(`Sliding to canvas ${index}`); // Debug log
        this.initializeCanvas(canvas, index);
      }
    });

    // Add listener for when slide completes
    carousel.addEventListener('slid.bs.carousel', (event) => {
      const currentSlide = event.relatedTarget;
      const canvas = currentSlide.querySelector('canvas');
      if (canvas) {
        const index = parseInt(canvas.getAttribute('data-canvas-index'));
        const fabricCanvas = this.canvases[index];
        if (fabricCanvas) {
          // Force resize and update on slide complete
          this.handleResize();
          this.updateAllCanvases(this.currentText);
        }
      }
    });
  }

  handleResize() {
    this.canvases.forEach((canvas, index) => {
      if (!canvas || !canvas.wrapperEl) return;

      const container = canvas.wrapperEl.parentElement;
      const width = container.offsetWidth;
      const height = container.offsetHeight;
      const style = this.getStyleForIndex(index);
      
      canvas.setWidth(width);
      canvas.setHeight(height);
      
      const text = canvas.getObjects('text')[0];
      if (text) {
        const responsiveFontSize = this.calculateResponsiveFontSize(width, height, style);
        const responsiveStrokeWidth = Math.max(2, Math.round((responsiveFontSize / style.fontSize) * style.strokeWidth));

        text.set({
          left: (width * style.left) / 100,
          top: (height * style.top) / 100,
          fontSize: responsiveFontSize,
          strokeWidth: responsiveStrokeWidth
        });
      }
      
      canvas.renderAll();
    });
  }

  getStyleForIndex(index) {
    const styles = [
      {
        color: '#ffffff',
        fontFamily: 'Barbieri Bold',
        fontSize: 105,
        stroke: '#34C1CD',
        strokeWidth: 15,
        left: 50,
        top: 35
      },
      {
        color: '#ffffff',
        fontFamily: 'Good Times',
        fontSize: 72,
        stroke: '#231F1F',
        strokeWidth: 25,
        left: 50,
        top: 35
      },
      {
        color: '#652F8F',
        fontFamily: 'Ferryman Bold',
        fontSize: 120,
        stroke: '#FCB12F',
        strokeWidth: 15,
        left: 50,
        top: 35
      },
      {
        color: '#000000',
        fontFamily: 'Lemon Milk Bold',
        fontSize: 75,
        stroke: '#F89941',
        strokeWidth: 15,
        left: 50,
        top: 35
      },
      {
        color: '#ffffff',
        fontFamily: 'Astounder Squared',
        fontSize: 140,
        stroke: '#5E7FBC',
        strokeWidth: 15,
        left: 50,
        top: 35
      },
      {
        color: '#ffffff',
        fontFamily: 'Margot Italic',
        fontSize: 90,
        stroke: '#BB6AA5',
        strokeWidth: 15,
        left: 50,
        top: 35
      },
      {
        color: '#ffffff',
        fontFamily: 'Cooper Black',
        fontSize: 90,
        stroke: '#231F20',
        strokeWidth: 15,
        left: 50,
        top: 35
      },
      {
        color: '#ffffff',
        fontFamily: 'Genica One',
        fontSize: 100,
        stroke: '#D6EDEF',
        strokeWidth: 15,
        left: 50,
        top: 35
      }
    ];
    return styles[index % styles.length];
  }

  updateAllCanvases(text) {
    this.canvases.forEach((canvas, index) => {
      if (!canvas) return;
      
      const textObject = canvas.getObjects('text')[0];
      if (textObject) {
        textObject.set('text', text);
        canvas.renderAll();
        console.log(`Updated text on canvas ${index}`); // Debug log
      }
    });
  }
}




// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new ProductCustomization();
}); 